<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Add payment
      @if (refund) {
        <p class="subtitle">Refund #{{refund.number}}</p>
      }
    </ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="add()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading && refund) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <ion-select cancelText="Close" interface="alert" label="Method" labelPlacement="stacked" fill="outline" [(ngModel)]="params.method" (ionChange)="methodChanged()">
                  @if (smartpay_connected || has_stripe_payments) {
                    <ion-select-option value="credit_card">Card</ion-select-option>
                  }
                  <ion-select-option value="bank_transfer">Bank transfer</ion-select-option>
                  <ion-select-option value="cash">Cash</ion-select-option>
                  @if (!smartpay_connected) {
                    <ion-select-option value="external_card">External card</ion-select-option>
                  }
                  @if (order.person && !order.organisation) {
                    <ion-select-option value="person_store_credit">Person store credit</ion-select-option>
                  }
                  @if (order.organisation) {
                    <ion-select-option value="organisation_store_credit">Organisation store credit</ion-select-option>
                  }
                  @if (custom_payment_services && custom_payment_services.length > 0) {
                    <ion-select-option value="custom">Custom</ion-select-option>
                  }
                </ion-select>
              </ion-col>
            </ion-row>
            @if (params.method == 'custom') {
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Close" interface="alert" label="Payment service" labelPlacement="stacked" fill="outline" [(ngModel)]="params.payment_service_id">
                    @for (custom_payment_service of custom_payment_services; track custom_payment_service) {
                      @if (custom_payment_service.status == 'active') {
                        <ion-select-option value="{{custom_payment_service.id}}">{{custom_payment_service.name}}</ion-select-option>
                      }
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
            }
            @if (params.method == 'custom') {
              <ion-row>
                <ion-col>
                  <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params.payment_service_transaction_id">
                    <div slot="label">Payment service transaction ID<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                </ion-col>
              </ion-row>
            }
            @if (credit_card_payments.length != 0 && stripe_connected && params.method == 'credit_card') {
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Close" interface="alert" label="Payment" labelPlacement="stacked" fill="outline" [(ngModel)]="params.originating_payment_id" (ionChange)="originatingPaymentChanged()">
                    @for (payment of credit_card_payments; track payment) {
                      @if (order) {
                        <ion-select-option value="{{payment.id}}">{{payment.payment_service.name}} ({{payment.price | currency:order.currency.code:'symbol-narrow':'1.2-2'}})</ion-select-option>
                      }
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
            }
            <ion-row>
              <ion-col>
                <ion-input type="tel" inputmode="decimal" maxlength="10" label="Amount" labelPlacement="stacked" fill="outline" [(ngModel)]="params.price"></ion-input>
              </ion-col>
            </ion-row>
            <ion-row >
              <ion-col>
                @if (params['date']) {
                  <ion-input class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" value={{formatted_date}} (click)="presentDateTimePickerModal()"></ion-input>
                }
                @if (!params['date']) {
                  <ion-input class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()"></ion-input>
                }
              </ion-col>
            </ion-row>
            @if (xero_connected && refund.xero_credit_note_id) {
              <ion-row>
                <ion-col>
                  <ion-item lines="none" class="ion-no-padding">
                    <ion-toggle class="form-toggle" alignment="start" label-placement="stacked" [(ngModel)]="params['add_xero_credit_note_payment']">Add payment to Xero credit note</ion-toggle>
                  </ion-item>
                </ion-col>
              </ion-row>
            }
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>